<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper" v-if="!userId">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="用户姓名">
                <a-input v-model="queryParam.userName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.userPhone" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['sys:fund:connect:edit']">
            <a-icon type="plus" />资金转账
          </a-button> -->
          <!-- <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['abm-fix:dev:edit']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['abm-fix:dev:remove']">
            <a-icon type="delete" />删除
          </a-button>
          <a-button type="primary" @click="handleUpload" v-hasPermi="['abm-fix:dev:import']"> 批量导入 </a-button>
          <a-button type="primary" @click="$refs.DevCan.init()" v-hasPermi="['abm-fix:dev-pressure:list']" v-if="userType==1">
            设备参数
          </a-button> -->
        </template>
        
      </div>
      <!-- 数据展示 -->
      <div class="table-operations">
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />
      </div>
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
         :pagination="false"
        :bordered="tableBordered">
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="userName" slot-scope="text, record">
          {{ record.userName }}/{{ record.userPhone }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.Folowing.handleUpdate(record, undefined)" v-hasPermi="['sys:fund:flowing:list']"> 流水 </a>
          <a-divider type="vertical" v-hasPermi="['sys:fund:connect:add']" v-if="userType == 1" />
          <a @click="$refs.createForm.handleUpdate(record, 1)" v-hasPermi="['sys:fund:connect:add']"
            v-if="userType == 1">
            调整金豆
          </a>
          <a-divider type="vertical" v-hasPermi="['sys:fund:connect:add']" v-if="userType == 1" />
          <a @click="$refs.createForm.handleUpdate(record, 2)" v-hasPermi="['sys:fund:connect:add']"> 调整积分 </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
      <!-- 调整积分 -->
      <create-form ref="createForm" :userList="userList" :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList" />
      <!-- 流水 -->
      <Folowing ref="Folowing" @ok="getList" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { connectPage, delObj } from '@/api/pressure/fund'
import CreateForm from './modules/CreateForm'
import Folowing from './modules/folowing'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
export default {
  name: 'Post',
  components: {
    CreateForm,
    Folowing,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    userId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '用户信息(名称/电话)',
          scopedSlots: { customRender: 'userName' },
          dataIndex: 'userName',
          align: 'center',
           width: '30%',
        },
        // {
        //   title: '用户手机号',
        //   dataIndex: 'userPhone',
        //   width: 120,
        //   align: 'center',
        // },
        {
          title: '单位名称',
          dataIndex: 'tenantName',
          align: 'center',
        },
        {
          title: '金豆',
          dataIndex: 'moneyTwo',
          align: 'center',
        },
        {
          title: '积分',
          dataIndex: 'point',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '200px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (this.userType == 1 || this.userType == 2) {
      this.columns.splice(1, 1)
    }
    if (!this.isOperate) {
      this.columns.pop()
    }
    if (this.userId) {
      this.queryParam.userId = this.userId
    }
    this.queryParam.tenantFirmId = this.tenantFirmId
    this.queryParam.tenantId = this.tenantId
    this.getList()
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      connectPage(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },
}
</script>
